import { render, staticRenderFns } from "./SalesVsTarget.vue?vue&type=template&id=ecc545f2"
import script from "./SalesVsTarget.vue?vue&type=script&lang=js"
export * from "./SalesVsTarget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports